import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export interface SetFacetCollapsePayload {
  facetGroup: string;
  facetName: string;
  collapsed: boolean;
}

export class SetFacetCollapseMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.setFacetCollapse]: (searchState: SearchState, { facetGroup, facetName, collapsed }: SetFacetCollapsePayload) => {
      searchState.facetsGroups[facetGroup].facets[facetName].collapsed = collapsed;
    }
  };
}
